import { Component, Inject, Input } from '@angular/core'
import { LeaderboardAppointment, LeaderboardClient } from '../../services/ppv.api'

@Component({
   selector: 'client-verification-rows',
   templateUrl: './client-verification-rows.component.html',
   styleUrls: ['./client-verification-rows.component.scss'],
   standalone: false,
})
export class ClientVerificationRowsComponent {
   @Input() practiceSKey: number = 0

   today = new Date().toISOString()

   constructor(private leaderboardClient: LeaderboardClient) {}

   errorTypeMap: Record<number, string> = {
      0: 'Null ErrorType',
      1: 'Missing/Incomplete',
      2: 'Possible Spam',
   }

   ngOnInit(): void {
      console.log('ON INIT')

      this.getLeaderboardAppointments()
   }

   allAppointments: LeaderboardAppointment[] = null
   unverifiedAppointments: LeaderboardAppointment[] = null

   getLeaderboardAppointments() {
      this.leaderboardClient.getLeaderboardAppointments(this.practiceSKey).subscribe({
         next: (data) => {
            console.log(data.length)

            // assign all
            this.allAppointments = data

            //filter to only unverified
            const unverified = data.filter((app) => app.isPhoneVerified !== true || app.isEmailVerified !== true)

            //deduplicate by FriendlyId, keeping the most recent StartTime
            const map = new Map<string, LeaderboardAppointment>()
            for (const app of unverified) {
               const existing = map.get(app.friendlyId)
               const appTime = new Date(app.startTime).getTime()

               if (!existing || appTime > new Date(existing.startTime).getTime()) {
                  map.set(app.friendlyId, app)
               }
            }

            //convert to array and sort by StartTime descending
            this.unverifiedAppointments = Array.from(map.values()).sort((a, b) => new Date(b.startTime).getTime() - new Date(a.startTime).getTime())

            console.log(this.unverifiedAppointments.length)
         },
         error: (error) => {
            console.error('Error fetching URL:', error)
         },
      })
   }


   openPrintableTable() {
      if (!this.unverifiedAppointments?.length) return

      const tableRows = this.unverifiedAppointments
         .map(
            (app) => `
    <tr>
      <td>${app.startTime ? new Date(app.startTime).toLocaleDateString() : ''}</td>
      <td>${app.displayName || ''}</td>
      <td>${app.friendlyId || ''}</td>
      <td>${app.emailAddress || ''} 
          ${app.isEmailVerified ? '✅' : app.emailVerificationErrorType === '2' ? '⚠' : '❌'}
      </td>
      <td>${app.phone || ''} 
          ${app.isPhoneVerified ? '✅' : app.phoneVerificationErrorType === '2' ? '⚠' : '❌'}
      </td>
    </tr>
  `
         )
         .join('')

      const popupWin = window.open('', '_blank', 'width=900,height=700')
      if (!popupWin) return

      const doc = popupWin.document
      doc.title = 'Unverified Clients'

      const style = doc.createElement('style')
      style.textContent = `
    body { 
      font-family: Arial, sans-serif; 
      padding: 1rem; 
      background-color: #fff;   /* force white background */
      color: #000;              /* force black text */
    }
    h2 { margin-bottom: 1rem; }
    table { border-collapse: collapse; width: 100%; background: #fff; }
    th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
    th { background-color: #f2f2f2; }
  `
      doc.head.appendChild(style)

      const heading = doc.createElement('h2')
      heading.textContent = `${this.unverifiedAppointments.length} Unverified Clients`
      doc.body.appendChild(heading)

      const table = doc.createElement('table')
      table.innerHTML = `
    <thead>
      <tr>
        <th>Visit Date</th>
        <th>Client Name</th>
        <th>Client ID</th>
        <th>Email</th>
        <th>Phone</th>
      </tr>
    </thead>
    <tbody>${tableRows}</tbody>
  `
      doc.body.appendChild(table)
   }
}
